import { ResizeObserver } from 'resize-observer'

export function findScrollParent(el: HTMLElement) {
	// tslint:disable-next-line:no-conditional-assignment
	while(el = el.parentElement as HTMLElement) {
		const overflowY = window.getComputedStyle(el).overflowY
		if(overflowY === 'auto' || overflowY === 'scroll') {
			return el
		}
	}
	return document.body
}

export function observeDimensions(el: Element, cb: (width: number, height: number) => void): ResizeObserver {
	const ro = new ResizeObserver(entries => {
		for(const entry of entries) {
			cb(entry.contentRect.width, entry.contentRect.height)
		}
	})
	ro.observe(el)
	return ro
}
